import { FC } from 'react';

import dashboardCampaignsFilterSearchFormFieldTouch from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaigns_filter_search_form_field_touch';
import Icon, { IconAppearance, IconKind, IconScale, IconView } from '@hh.ru/bloko/build/blocks/icon';
import useDebounce from '@hh.ru/bloko/build/common/hooks/useDebounce';
import { useBreakpoint } from '@hh.ru/magritte-ui';

import InputText, { InputType } from 'bloko/blocks/inputText';

import { useRequestCancel } from 'hooks/common/useRequestCancel';
import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { fetchCampaignsSearch } from 'components/Dashboard/CampaignsSearch/fetchCampaignsSearch';

import { setCampaignSearchValue, setIsCampaignSearchLoading } from 'store/models/dashboard';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/Dashboard/CampaignsSearch/CampaignsSearch.module.less';

const TrlKeys = {
    searchPlaceholder: 'Dashboard.CampaignsSearch.CampaignsSearch.placeholder',
    searchPlaceholderIsMobile: 'Dashboard.CampaignsSearch.CampaignsSearch.placeholder.isMobile',
};

const CampaignsSearch: FC = () => {
    const campaignSearchValue = useSelector((state) => state.dashboard.campaignSearchValue);
    const isCampaignSearchLoading = useSelector((state) => state.dashboard.isCampaignSearchLoading);
    const { abortRequest, abortSignal } = useRequestCancel();

    const trl = useTrls();
    const dispatch = useDispatch();
    const { isXS } = useBreakpoint();

    const debouncedSearch = useDebounce((newSearchValue) => {
        abortRequest();
        void dispatch(setIsCampaignSearchLoading(true));
        void dispatch(fetchCampaignsSearch(newSearchValue, abortSignal()));
    }, 1000);

    const onSearchValueChange = (newSearchValue: string) => {
        dispatch(setCampaignSearchValue(newSearchValue));
        debouncedSearch(newSearchValue);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.innerWrapper}>
                <InputText
                    autoSave="search-campaign-input"
                    onChange={onSearchValueChange}
                    placeholder={isXS ? trl(TrlKeys.searchPlaceholderIsMobile) : trl(TrlKeys.searchPlaceholder)}
                    prefix={
                        <Icon
                            appearance={IconAppearance.Outlined}
                            kind={IconKind.Default}
                            scale={IconScale.Small}
                            view={IconView.Lupa}
                        />
                    }
                    type={InputType.Search}
                    showClearButton
                    showLoading={isCampaignSearchLoading}
                    value={campaignSearchValue}
                    data-qa="search-campaign-input"
                    onFocus={() => {
                        dashboardCampaignsFilterSearchFormFieldTouch();
                    }}
                />
            </div>
        </div>
    );
};

export default withErrorBoundary(CampaignsSearch);
